import Swiper from 'swiper/bundle';
import { throttle } from 'lodash';

export default (function () {
  return {
    init() {
      window.addEventListener('load', this.initPromoSwiper);
      window.addEventListener('load',   this.initProductSwiper);
      window.addEventListener('load', this.initTestimonialsCarousel);
      window.addEventListener('load', this.initMarketSwiper);
      window.addEventListener('load', this.initRelatedContentSlider);

	  window.addEventListener('resize', throttle(this.initMarketSwiper, 14));
	  window.addEventListener('resize', throttle(this.initRelatedContentSlider, 14));
    },

    initPromoSwiper() {
      const sliders = document.querySelectorAll('.js-promo-slider');

      if (sliders.length === 0) return;

      [...sliders].forEach((slider) => {
        const parent = slider.parentElement;
        const pagination = parent.querySelector('.swiper-pagination');

        const promotionalCarousel = new Swiper(slider, {
          slidesPerView: 1,
          speed: 1500,
          autoplay: {
            delay: 5000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
          },
          freeMode: true,
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          navigation: {
            nextEl: '.promo-next',
            prevEl: '.promo-prev',
          },
          pagination: {
            el: pagination,
            clickable: true,
          },
        });

        const mySwiper = slider.swiper;

        slider.addEventListener('mouseenter', () => {
          mySwiper.autoplay.stop();
        });
        slider.addEventListener('mouseleave', () => {
          mySwiper.autoplay.start();
        });
      });
    },

    initProductSwiper() {
      const sliders = document.querySelectorAll('.js-product-carousel');

      if (sliders.length === 0) return;

      [...sliders].forEach((slider) => {
		  const parent = slider.parentElement;
		  const pagination = parent.querySelector('.swiper-pagination');
		  const nextArrow = parent.querySelector('.swiper-button-next');
		  const prevArrow = parent.querySelector('.swiper-button-prev');

		  const productCarousel = new Swiper(slider, {
          slidesPerView: 1.2,
          centeredSlides: true,
          spaceBetween: 40,
          speed: 1500,
          freeMode: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          pagination: {
            el: pagination,
            clickable: true,
          },
          watchOverflow: true,
          breakpoints: {
            1024: {
              slidesPerView: 3,
              centeredSlides: false,
            },
            768: {
              slidesPerView: 1.5,
              spaceBetween: 0,
            },
            320: {
              spaceBetween: 0,
            }
          },
		  });
      });
    },

    initMarketSwiper() {
      if(window.innerWidth < 768) {
        const sliders = document.querySelectorAll('.js-market-slider');

        if (sliders.length === 0) return;

        [...sliders].forEach((slider) => {
          const parent = slider.parentElement;
          const pagination = parent.querySelector('.swiper-pagination');

          const marketCarousel = new Swiper(slider, {
            slidesPerView: 'auto',
            speed: 1500,
            pagination: {
              el: pagination,
              clickable: true,
            },
            on: {
              slideChange: (e) => {
                e.pagination.render();
                e.pagination.update();
              },
            },
          });
        });
      }
	  },

	  initTestimonialsCarousel() {
      const sliders = document.querySelectorAll('.js-testimonials');

      if(sliders.length === 0) return;

      sliders.forEach(slider => {
        const parent = slider.parentElement;
        const pagination = parent.querySelector('.swiper-pagination');

        const testimonialsCarousel = new Swiper(slider, {
          slidesPerView: 1,
          speed: 3000,
          freeMode: true,
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          pagination: {
            el: pagination,
            clickable: true,
          },
        });
      });
	  },

	  initRelatedContentSlider() {
	  if(window.innerWidth < 1025) {
		  const sliders = document.querySelectorAll('.js-related-slider');

		  if (sliders.length === 0) return;

		  [...sliders].forEach((slider) => {
          const parent = slider.parentElement;
          const pagination = parent.querySelector('.swiper-pagination');

          const relatedContentCarousel = new Swiper(slider, {
			  slidesPerView: 1.4,
			  centeredSlides: 'true',
			  spaceBetween: 20,
			  speed: 1500,
			  initialSlide: 1,
			  pagination: {
              el: pagination,
              clickable: true,
			  },
          });
		  });
	  }
    },
  };
})();
